var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"breadcrumb-bar",attrs:{"bordered":false,"shadow":""}},[(_vm.name)?_c('Breadcrumb',{staticStyle:{"margin-left":"0.2rem"},attrs:{"separator":"/"}},[(_vm.name)?_c('BreadcrumbItem',[_vm._v(_vm._s(_vm.name))]):_vm._e(),(_vm.subName)?_c('BreadcrumbItem',[_vm._v(_vm._s(_vm.subName))]):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }